const Host = "https://thekindergartenintl-cms-dwaq.onrender.com";
// const Host = "https://thekindergartenintl-cms.onrender.com";
export default Host;
